module.exports = __webpack_public_path__ + "static/phpstorm-7aaa9e90c341c7735ce5d12129b6693f.png";